<template>
  <div class="row">
    <div class="col-12 col-sm-6 pb-3">
      <PlanOptions
        show-summer-plans
        :survey="survey"
        :survey-options="surveyOptions"
        :form-name="formName"
        :rules="rules"
      />
    </div>
    <div class="col-12 col-sm-6 pb-3">
      <ForwardingAddress
        :states="states"
        :countries="countries"
        :survey="survey"
        :form-name="formName"
        :rules="rules"
      />
    </div>

    <div v-if="survey.customAcknowledgement" class="col-12 pb-3">
      <BaseCheckBox
        v-model="acknowledgement"
        :rules="[(v: string) => v || 'required']"
        :form-name="formName"
        name="acknoledgement"
        :label="survey.customAcknowledgement"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { CountryOptions, StateOptions } from "@/shared/BaseAddress.vue";

import { FuturePlanOption, FuturePlansSurvey } from "../types";
import { Rules } from "../useValidations";
import ForwardingAddress from "./ForwardingAddress.vue";
import PlanOptions from "./PlanOptions.vue";

interface Props {
  states: StateOptions;
  countries: CountryOptions;
  surveyOptions: FuturePlanOption[];
  survey: FuturePlansSurvey;
  formName: string;
  rules: Rules;
}

defineProps<Props>();
const acknowledgement = ref(false);
</script>
